import { Icon } from '../../components/Icon';
import { useI18n } from '../../i18n/i18n-context';

/** A download's button, which says for a moment that the download has started. */
export function DownloadButton({
  href,
  label,
  started,
  onStart,
  fileName,
}: {
  readonly href: string;
  /** What's downloaded, for screen readers: "Download Mac Apple silicon". */
  readonly label: string;
  readonly started: boolean;
  readonly onStart: () => void;
  /** Names the file, for downloads the server doesn't name. */
  readonly fileName?: string;
}) {
  const { t } = useI18n();
  return (
    <a
      className="button button--primary download-app-button"
      href={href}
      download={fileName}
      aria-label={label}
      data-started={started || undefined}
      onClick={onStart}
    >
      <span className="download-app-button-icon" key={started ? 'started' : 'ready'}>
        <Icon name={started ? 'check' : 'download'} />
      </span>
      <span className="download-app-button-label">
        {started ? t.downloads.started : t.downloads.download}
      </span>
    </a>
  );
}
